// ANX-046 — visitor bans REST API (admin / operator).
import type { ApiClient } from './client';

export interface VisitorBan {
  id: string;
  visitorId: string;
  lastIp?: string;
  reason: string;
  bannedBy?: string;
  expiresAt?: string;
  createdAt: string;
  active: boolean;
}

interface RawBan {
  id: string;
  visitor_id: string;
  last_ip?: string;
  reason: string;
  banned_by?: string;
  expires_at?: string;
  created_at: string;
  active: boolean;
}

function toBan(raw: RawBan): VisitorBan {
  const b: VisitorBan = {
    id: raw.id,
    visitorId: raw.visitor_id,
    reason: raw.reason,
    createdAt: raw.created_at,
    active: raw.active,
  };
  if (raw.last_ip) b.lastIp = raw.last_ip;
  if (raw.banned_by) b.bannedBy = raw.banned_by;
  if (raw.expires_at) b.expiresAt = raw.expires_at;
  return b;
}

export async function banVisitor(
  client: ApiClient,
  visitorId: string,
  input: { durationSeconds?: number; reason?: string },
): Promise<VisitorBan> {
  const body: Record<string, unknown> = {
    duration_seconds: input.durationSeconds ?? 0,
    reason: input.reason ?? '',
  };
  const raw = await client.request<RawBan>(`/api/v1/visitors/${visitorId}/ban`, {
    method: 'POST',
    json: body,
  });
  return toBan(raw);
}

export async function listVisitorBans(client: ApiClient): Promise<VisitorBan[]> {
  const raw = await client.request<{ visitor_bans: RawBan[] }>('/api/v1/bans');
  return raw.visitor_bans.map(toBan);
}

export async function deleteVisitorBan(client: ApiClient, banId: string): Promise<void> {
  await client.request<void>(`/api/v1/bans/${banId}`, { method: 'DELETE' });
}
